/**
 * O2C 商品オプション機構 (Globo Product Options 代替)
 * ------------------------------------------------------------------
 * ・商品ページ: 選択に応じて合計金額を再計算 / 必須バリデーション /
 *   本体+アドオン(追加料金バリアント)を /cart/add.js で一括追加
 * ・カート: _parent_key を持つアドオン行の孤児検出・自動削除 / 親数量への追随
 *
 * dropdown はテーマ純正の x-popover / x-listbox を流用(listbox:change を購読)。
 * text は textarea。snippet: snippets/o2c-options.liquid。
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* --------------------------------------------------------------- money */
  function formatMoney(cents) {
    var format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '¥{{amount_no_decimals}}';
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;

    function withCommas(num) { return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); }
    function toDecimal(amount, precision) {
      precision = precision == null ? 2 : precision;
      return (parseInt(amount, 10) / 100).toFixed(precision);
    }

    switch (format.match(placeholderRegex) ? format.match(placeholderRegex)[1] : '') {
      case 'amount': value = withCommas(toDecimal(cents, 2)); break;
      case 'amount_no_decimals': value = withCommas(toDecimal(cents, 0)); break;
      case 'amount_with_comma_separator': value = toDecimal(cents, 2).replace(/,/g, '.').replace('.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withCommas(toDecimal(cents, 0)); break;
      case 'amount_with_space_separator': value = toDecimal(cents, 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 '); break;
      case 'amount_no_decimals_with_space_separator': value = toDecimal(cents, 0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 '); break;
      default: value = withCommas(toDecimal(cents, 0));
    }
    return format.replace(placeholderRegex, value);
  }

  function genKey() {
    return 'opt_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 6);
  }

  /* --------------------------------------------------- option controller */
  function O2COptions(el) {
    this.el = el;
    this.form = document.getElementById(el.getAttribute('form'));
    var configEl = el.querySelector('.o2c-config');
    try {
      this.config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[O2C] config の解析に失敗', e);
      this.config = null;
      return;
    }
    this.basePriceCents = parseInt(this.config.basePriceCents, 10) || 0;
    this.notesEl = el.querySelector('.o2c-notes');
    this.totalEl = el.querySelector('.o2c-summary');
    this.totalValueEl = el.querySelector('.o2c-total__value');
    this.addonEl = el.querySelector('.o2c-total__addon');

    this.groups = Array.prototype.map.call(el.querySelectorAll('[data-o2c-group]'), function (g) {
      return new O2CGroup(g, this);
    }, this);

    this._bind();
    this.updateTotal();
    el.__o2c = this;
  }

  O2COptions.prototype._bind = function () {
    var self = this;
    // textarea の入力で再計算(dropdown は選択時に直接 updateTotal を呼ぶ)。
    this.el.addEventListener('input', function () { self.updateTotal(); });

    if (this.form) {
      this.form.addEventListener('variant:change', function (event) {
        var variant = event.detail && event.detail.variant;
        if (variant && typeof variant.price !== 'undefined') {
          self.basePriceCents = parseInt(variant.price, 10) || 0;
          self.updateTotal();
        }
      });
    }
  };

  O2COptions.prototype.currentSurchargeCents = function () {
    return this.groups.reduce(function (sum, g) {
      var v = g.getValue();
      return sum + (v.surcharge > 0 ? v.surcharge * 100 : 0);
    }, 0);
  };

  O2COptions.prototype.updateTotal = function () {
    if (!this.totalEl) return;
    var surcharge = this.currentSurchargeCents();
    var total = this.basePriceCents + surcharge;
    this.totalValueEl.textContent = formatMoney(total);
    if (this.addonEl) this.addonEl.textContent = '+' + formatMoney(surcharge);
    this.totalEl.hidden = false;
  };

  O2COptions.prototype.validate = function () {
    var firstInvalid = null;
    this.groups.forEach(function (g) {
      if (!g.validate() && !firstInvalid) firstInvalid = g;
    });
    if (firstInvalid) {
      if (firstInvalid.control && firstInvalid.control.focus) firstInvalid.control.focus();
      return false;
    }
    return true;
  };

  O2COptions.prototype.buildItems = function () {
    var cfg = this.config;
    var fd = new FormData(this.form);
    var mainVariantId = fd.get('id');
    var quantity = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
    var optionsKey = genKey();

    var mainProps = {};
    fd.forEach(function (value, name) {
      var m = name.match(/^properties\[(.+)\]$/);
      if (!m || value === '' || typeof value !== 'string') return;
      mainProps[m[1]] = value;
    });

    var addonItems = [];
    this.groups.forEach(function (g) {
      var v = g.getValue();
      if (g.inputType === 'text') {
        if (v.label) mainProps[g.name] = v.label;
        return;
      }
      if (!v.label) return;
      var suffix = v.surcharge > 0 ? '（+' + formatMoney(v.surcharge * 100) + '）' : '';
      mainProps[g.name] = v.label + suffix;

      if (v.surcharge > 0) {
        var variantId = cfg.addonVariants[v.surcharge];
        if (variantId) {
          addonItems.push({
            id: variantId,
            quantity: quantity,
            properties: {
              '対象': cfg.productTitle,
              '内容': g.name + ': ' + v.label,
              '_parent_key': optionsKey
            }
          });
        } else {
          console.warn('[O2C] surcharge=' + v.surcharge + ' に対応するアドオンバリアントがありません');
        }
      }
    });

    if (this.notesEl && this.notesEl.value.trim()) {
      mainProps[cfg.notesLabel] = this.notesEl.value.trim();
    }
    mainProps['_options_key'] = optionsKey;

    var items = [{ id: mainVariantId, quantity: quantity, properties: mainProps }];
    return items.concat(addonItems);
  };

  O2COptions.prototype.addToCart = function () {
    var form = this.form;
    var items = this.buildItems();

    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: sections }
    }));

    var submitButtons = Array.prototype.filter.call(form.elements, function (b) { return b.type === 'submit'; });
    submitButtons.forEach(function (b) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-busy', 'true'); });

    var mainId = items[0].id;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: root + 'variants/' + mainId })
    }).then(function (response) {
      return response.json().then(function (json) { return { ok: response.ok, json: json }; });
    }).then(function (res) {
      submitButtons.forEach(function (b) { b.removeAttribute('disabled'); b.removeAttribute('aria-busy'); });
      if (res.ok) {
        var settings = window.themeVariables && window.themeVariables.settings;
        if (settings && (settings.cartType === 'page' || settings.pageType === 'cart')) {
          window.location.href = root + 'cart';
          return;
        }
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = res.json.sections;
          form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: res.json.items || [res.json], cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        });
      } else {
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: res.json.description } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }).catch(function (err) {
      submitButtons.forEach(function (b) { b.removeAttribute('disabled'); b.removeAttribute('aria-busy'); });
      console.error('[O2C] カート追加に失敗', err);
    });
  };

  /* ------------------------------------------------------ group control */
  var openDropdowns = []; // 現在開いているドロップダウンの登録簿

  function closeAllDropdowns(except) {
    openDropdowns.slice().forEach(function (g) { if (g !== except) g.close(); });
  }

  function O2CGroup(groupEl, parent) {
    this.el = groupEl;
    this.parent = parent;
    this.name = groupEl.getAttribute('data-name');
    this.inputType = groupEl.getAttribute('data-input-type') || 'dropdown';
    this.required = groupEl.getAttribute('data-required') === 'true';
    this.errorEl = groupEl.querySelector('.o2c-field__error');

    this.selected = null;
    var self = this;

    if (this.inputType === 'text') {
      this.control = groupEl.querySelector('.o2c-textarea');
      if (this.control) this.control.addEventListener('input', function () { self.clearError(); });
      return;
    }

    // --- custom dropdown ---
    this.dropdown = groupEl.querySelector('.o2c-dropdown');
    this.trigger = groupEl.querySelector('.o2c-dd-trigger');
    this.valueEl = groupEl.querySelector('.o2c-dd-value');
    this.panel = groupEl.querySelector('.o2c-dd-panel');
    this.options = Array.prototype.slice.call(groupEl.querySelectorAll('.o2c-dd-option'));
    this.control = this.trigger; // バリデーション時のフォーカス先

    this.trigger.addEventListener('click', function (e) {
      e.preventDefault();
      self.isOpen() ? self.close() : self.open();
    });
    this.trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.open(); }
    });

    this.options.forEach(function (opt) {
      opt.addEventListener('click', function (e) { e.preventDefault(); self.select(opt); });
    });
  }

  O2CGroup.prototype.isOpen = function () {
    return this.dropdown && this.dropdown.classList.contains('o2c-dropdown--open');
  };

  O2CGroup.prototype.open = function () {
    if (!this.panel || this.isOpen()) return;
    closeAllDropdowns(this);
    this.panel.hidden = false;
    this.dropdown.classList.add('o2c-dropdown--open');
    this.trigger.setAttribute('aria-expanded', 'true');
    if (openDropdowns.indexOf(this) === -1) openDropdowns.push(this);
  };

  O2CGroup.prototype.close = function () {
    if (!this.panel) return;
    this.panel.hidden = true;
    this.dropdown.classList.remove('o2c-dropdown--open');
    this.trigger.setAttribute('aria-expanded', 'false');
    var i = openDropdowns.indexOf(this);
    if (i !== -1) openDropdowns.splice(i, 1);
  };

  O2CGroup.prototype.select = function (opt) {
    this.selected = {
      label: opt.getAttribute('data-value'),
      surcharge: parseInt(opt.getAttribute('data-surcharge'), 10) || 0
    };
    if (this.valueEl) {
      this.valueEl.textContent = opt.getAttribute('data-title') || opt.getAttribute('data-value');
      this.valueEl.classList.remove('o2c-dd-value--placeholder');
    }
    this.options.forEach(function (o) {
      var on = o === opt;
      o.classList.toggle('o2c-dd-option--selected', on);
      o.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.close();
    this.clearError();
    this.parent.updateTotal();
  };

  O2CGroup.prototype.getValue = function () {
    if (this.inputType === 'text') {
      return { label: this.control ? this.control.value.trim() : '', surcharge: 0 };
    }
    return this.selected || { label: '', surcharge: 0 };
  };

  O2CGroup.prototype.validate = function () {
    if (!this.required) return true;
    if (!this.getValue().label) { this.showError('この項目を選択してください'); return false; }
    this.clearError();
    return true;
  };

  O2CGroup.prototype.showError = function (msg) {
    if (this.errorEl) { this.errorEl.textContent = msg; this.errorEl.hidden = false; }
    if (this.control) this.control.setAttribute('aria-invalid', 'true');
    this.el.classList.add('o2c-field--error');
  };

  O2CGroup.prototype.clearError = function () {
    if (this.errorEl) this.errorEl.hidden = true;
    if (this.control) this.control.removeAttribute('aria-invalid');
    this.el.classList.remove('o2c-field--error');
  };

  // 外側クリック / Escape で開いているドロップダウンを閉じる
  document.addEventListener('click', function (event) {
    if (!openDropdowns.length) return;
    if (event.target.closest && event.target.closest('.o2c-dropdown')) return;
    closeAllDropdowns();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllDropdowns();
  });

  /* ------------------------------------------- submit interception (capture) */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('is') !== 'product-form') return;
    // 注意: 商品フォームは <input name="id"> を含むため form.id は input にシャドーされる。
    var formId = form.getAttribute('id');
    if (!formId) return;
    var opts = document.querySelector('o2c-options[form="' + (window.CSS && CSS.escape ? CSS.escape(formId) : formId) + '"]');
    if (!opts || !opts.__o2c) return;

    var controller = opts.__o2c;
    event.preventDefault();
    event.stopPropagation();
    if (!controller.validate()) return;
    controller.addToCart();
  }, true);

  /* ----------------------------------------------- cart integrity guard */
  var cartBusy = false;
  function o2cCartIntegrity() {
    if (cartBusy) return Promise.resolve();
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      var parentKeys = {};
      var parentQty = {};
      items.forEach(function (it) {
        var k = it.properties && it.properties._options_key;
        if (k) { parentKeys[k] = true; parentQty[k] = it.quantity; }
      });

      var updates = [];
      items.forEach(function (it) {
        var pk = it.properties && it.properties._parent_key;
        if (!pk) return;
        if (!parentKeys[pk]) {
          updates.push({ key: it.key, quantity: 0 });
        } else if (parentQty[pk] != null && it.quantity !== parentQty[pk]) {
          updates.push({ key: it.key, quantity: parentQty[pk] });
        }
      });

      if (!updates.length) return;
      cartBusy = true;
      var chain = Promise.resolve();
      updates.forEach(function (u) {
        chain = chain.then(function () {
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: u.key, quantity: u.quantity })
          });
        });
      });
      return chain.then(function () {
        cartBusy = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function (e) {
        cartBusy = false;
        console.error('[O2C] カート整合性の修正に失敗', e);
      });
    }).catch(function () { /* noop */ });
  }

  /* ------------------------------------------------------------- init */
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('o2c-options'), function (el) {
      if (!el.__o2c) new O2COptions(el);
    });
    o2cCartIntegrity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:change', function () { o2cCartIntegrity(); });
})();
